import $ from "jquery";

$('.numero-cristal a').click(function(event) {
    event.preventDefault();
    $('.numero-cristal .numero-visible').toggleClass('visible');
});
